// import router from '../../router'
import {
  NS_PATIENTS_SEARCH, NS_PATIENTS_SEARCH_SUCCESS, NS_PATIENTS_SEARCH_FAILURE, NS_PATIENT_SEARCH, NS_PATIENT_SEARCH_SUCCESS, NS_PATIENT_SEARCH_FAILURE, NS_PATIENT_MATCHING, NS_PATIENT_MATCHING_SUCCESS, NS_PATIENT_MATCHING_FAILURE
} from './mutation-types'

export default {
  state: {
    patients: null,
    patient: null
  },
  getters: {
    ns_patients: state => {
      return state.patients
    },
    ns_patient: state => {
      return state.patient
    }
  },
  actions: {
    [NS_PATIENTS_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/patients'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_PATIENTS_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_PATIENTS_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_PATIENT_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/patients/' + params.data.patient_code
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiGet', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_PATIENT_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_PATIENT_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [NS_PATIENT_MATCHING] ({dispatch, state, commit}, params = null) {
      var url = '/nsips/patients/matching'
      var callback = () => {}
      if (params.callback) {
        callback = params.callback
      }
      dispatch('apiPost', { url: url, data: params.data })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(NS_PATIENT_MATCHING_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(NS_PATIENT_MATCHING_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [NS_PATIENTS_SEARCH_FAILURE] (state, data) {
      console.log('NS_PATIENTS_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_PATIENTS_SEARCH_SUCCESS] (state, params) {
      console.log('NS_PATIENTS_SEARCH_SUCCESS')
      state.patients = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_PATIENT_SEARCH_FAILURE] (state, data) {
      console.log('NS_PATIENT_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [NS_PATIENT_SEARCH_SUCCESS] (state, params) {
      console.log('NS_PATIENT_SEARCH_SUCCESS')
      state.patient = params.data.data
      if (params.callback) {
        params.callback()
      }
    },
    [NS_PATIENT_MATCHING_SUCCESS] (state, params) {
      console.log('NS_PATIENT_MATCHING_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    [NS_PATIENT_MATCHING_FAILURE] (state, data) {
      console.log('NS_PATIENT_MATCHING_FAILURE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ns-patient.js